export default "__VITE_ASSET__ce22e484__"